import { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
// prime react
import { Button } from "primereact/button";
// components
import { Header } from "./Header";
import { Table } from "./Table";
import Panel from "../../../../components/panel/panel";
import Select from "../../../../components/input/Select";
import Toggle from "../../../../components/button/Toggle";
//services
import { getSchedules } from "../../../../services/GlobalRoles/getSchedules";
import { filterAdjustment } from "../../../../services/Enterprise/ContratctAdjustment/filterAdjustment";
import { scheduleReadjust } from "../../../../services/Enterprise/ContratctAdjustment/scheduleReadjust";
import usePermission from "../../../../hooks/usePermission";
import { useAppContext } from "../../../../context/AppContext";

const ContractAdjustment = () => {
  usePermission("23"); // Visualizar Reajustar Contratos
  const { permissions } = useAppContext();
  const form = useForm();
  const errors = form.formState.errors;
  const { id } = useParams();

  const [filter, setFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [dataTable, setDataTable] = useState([]);

  const [selectedCustomers, setSelectedCustomers] = useState([]);

  const { data: schedules, refetch: refetchSchedule } = useQuery({
    queryKey: ["schedules"],
    queryFn: () => getSchedules(),
    // refetchOnWindowFocus: false,
    // retry: false,
    enabled: permissions?.includes("2"),
  });

  const onSubmit = async (data) => {
    setLoading(true);

    data.enterprise_id = id;

    setFilter(data);

    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    try {
      const response = await filterAdjustment(data);
      let obj = [];

      Object.keys(response).map((item) => obj.push(response[item])); // array of objects

      obj.map((row) => {
        row.block_land = row.block + " / " + row.land;
        if (!row.date_readjust) {
          row.date_readjust = row.created_at;
        }
        if (data.type === true) {
          row.type_filter = "monthly";
        } else {
          row.type_filter = "annual";
        }
      });

      setDataTable(obj);

      toast.update(notification, {
        render: "Consulta realizada com sucesso!",
        type: "success",
        theme: "colored",
        autoClose: 3000,
        isLoading: false,
      });
    } catch (e) {
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 3000,
        isLoading: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const onSubmitReadjust = async (data) => {
    const salesIds = selectedCustomers.map((customer) => customer.id);

    // Obter o tipo de reajuste do primeiro item (caso todos sejam iguais)
    const typeReadjust = selectedCustomers[0].type_filter;

    // Criar o objeto final
    const newObj = {
      sales_ids: salesIds,
      type_readjust: typeReadjust,
    };

    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    try {
      await scheduleReadjust(newObj);

      toast.update(notification, {
        render: "Reajuste de contrato agendado com sucesso",
        type: "info",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    } catch (e) {
      toast.update(notification, {
        render: "Houve um erro ao agendar reajuste, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 3000,
        isLoading: false,
      });
    } finally {
      form.reset();
      setSelectedCustomers([]);
      refetchSchedule();
      setDataTable({});
      setLoading(false);
    }
  };

  const optionsMonths = [
    { value: 1, label: "Janeiro" },
    { value: 2, label: "Fevereiro" },
    { value: 3, label: "Março" },
    { value: 4, label: "Abril" },
    { value: 5, label: "Maio" },
    { value: 6, label: "Junho" },
    { value: 7, label: "Julho" },
    { value: 8, label: "Agosto" },
    { value: 9, label: "Setembro" },
    { value: 10, label: "Outubro" },
    { value: 11, label: "Novembro" },
    { value: 12, label: "Dezembro" },
  ];

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <Header
          onSubmitReadjust={onSubmitReadjust}
          schedules={schedules}
          isDisable={isDisable}
          selectedCustomers={selectedCustomers}
        />
        <Panel title="Informe o Período">
          <form
            className="row d-flex mt-4 align-items-center"
            onSubmit={form.handleSubmit(onSubmit)}
          >
            <div className="col-xl-2 col-md-5 mb-3 form-group d-flex align-items-center">
              <Toggle
                name="type"
                onLabel="Mensal"
                offLabel="Anual"
                preValue={false}
                tooltip="Caso este campo esteja habilitado, trará todas vendas para reajuste mensal"
                tooltipOptions={{ position: "top" }}
                className="mt-2 w-100"
                control={form.control}
                getFormErrorMessage={getFormErrorMessage}
              />
            </div>
            
            <div className="col-xl-3 col-md-5 mb-5 form-group">
              <Select
                name="mes"
                control={form.control}
                label="Mês referência (venda)"
                isRequired={true}
                options={optionsMonths}
                errors={errors}
              />
            </div>
            <div className="col-xl-1 col-md-2 mb-3 form-group d-flex align-items-center">
              <Button
                type="submit"
                icon="fa fa-search"
                aria-label="Search"
                loading={loading}
                className="rounded-3 py-2.5 w-100"
              />
            </div>
          </form>
        </Panel>

        {dataTable.length > 0 && (
          <Table
            dataTable={dataTable}
            selectedCustomers={selectedCustomers}
            setSelectedCustomers={setSelectedCustomers}
          />
        )}
      </div>
    </>
  );
};

export default ContractAdjustment;
